import React from 'react';

interface ProgressProps {
  value: number;
  className?: string;
}

export const Progress: React.FC<ProgressProps> = ({
  value,
  className = ''
}) => {
  const percentage = Math.min(100, Math.max(0, value));

  return (
    <div className={`w-full bg-line rounded-full overflow-hidden ${className}`}>
      <div
        className="bg-gradient-accent h-full rounded-full transition-all duration-300 ease-out"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};
